import {useContext, useEffect, useRef} from "react"
import {toast} from "react-toastify"
import {DataContext} from "./DataContextProvider"
import {addNotification} from "./notification-helpers"

const NotificationListener = () => {
    const {setData} = useContext(DataContext)
    const counterRef = useRef(0)

    useEffect(() => {
        const dismissedIds = new Set()
        let dismissAll = false

        const originalDismiss = toast.dismiss
        toast.dismiss = (arg) => {
            if (arg == null) {
                dismissAll = true
                queueMicrotask(() => {
                    dismissAll = false
                })
            } else {
                const id = typeof arg === "object" ? arg.id : arg
                if (id != null) {
                    dismissedIds.add(String(id))
                }
            }
            return originalDismiss(arg)
        }

        const unsubscribe = toast.onChange((payload) => {
            if (payload.status !== "removed") return

            if (payload.reason) return

            const id = String(payload.id)

            if (dismissAll) return
            if (dismissedIds.has(id)) {
                dismissedIds.delete(id)
                return
            }

            const message =
                typeof payload.content === "string"
                    ? payload.content
                    : "(Benachrichtigung)"

            addNotification(setData, {
                id: `notification-${counterRef.current++}`,
                message,
                type: payload.type ?? "default",
                timestamp: Date.now(),
            })
        })

        return () => {
            unsubscribe()
            toast.dismiss = originalDismiss
        }
    }, [setData])

    return null
}

export default NotificationListener
